import React,{useEffect, useState} from 'react';
import Navbar from '../Navbar';
import '../../App.css';
import Cards from '../Cards';
import HeroSection from '../Herosection';
import About from '../About';
import axios from 'axios';
//import Footer from '../Footer';

function Home() {
  console.log('Home')
  useEffect(() => {
    // document.getElementById('body').style.display='none'
  }, [])
  let [val,setV]=useState(0)
  function setval(e,ee){
    setV(e);
    console.log(ee)
    document.getElementsByClassName('asd')[0].style.backgroundColor=`rgba(255, 255, 255,${val-0.1})`
  }
  return (
    <div onWheel={(e)=>setval(e.pageY/2000,e)}  className='landing'>
      <Navbar/>
      <HeroSection />
      <Cards />
    </div>
  );
}

export default Home;
